import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export function RecaptchaProvider({ children }) {
    const recaptchaKey = import.meta.env.VITE_GOOGLE_RECAPTCH_KEY || "key not foud";

    return (
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>
            {children}
        </GoogleReCaptchaProvider>
    );
}